import React from 'react'
import PropTypes from 'prop-types'
import './Card.scss'

const Card = ({ title, description, url, image, onClick = () => {} }) => (
  <a href={url} className="card" onClick={onClick}>
    <img src={image} alt={title} className="card__image" />
    <div className="card__content">
      <h3>{title}</h3>
      <p>{description}</p>
    </div>
  </a>
)

Card.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  url: PropTypes.string,
  image: PropTypes.string,
  onClick: PropTypes.func,
}
export default Card
